import $axios from "../api/accessor";
import { $api } from "../api/api";
import { getCookie } from "../utils/utils";

const token = getCookie("BscAdminToken");

export const SettingsService = {
  async getAllSettings() {
    let response = await $axios.get($api("settings")).catch((err) => {
      return err.response;
    });
    return {
      data: response?.data ? response?.data : [],
      status: response?.status,
    };
  },

  async addSettings(payload: any) {
    try {
      const { data, status } = await $axios.post($api("settings"), payload, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return { data, status };
    } catch (err: any) {
      const errorMessage = err.response?.data?.message;
      return { data: null, status: err.response?.status, errorMessage };
    }
  },

  async updateSettingById(id: number | string, payload: any) {
    let { data: responseData, status } = await $axios
      .put($api("settings_id", { id }), payload, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
      .catch((err) => {
        return err.response;
      });
    return { data: responseData, status };
  },

  async updateSettings(requestData: any) {
    let { data: responseData, status } = await $axios
      .put(
        $api("bulkUpdate"),
        { data: requestData },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      )
      .catch((err) => {
        return err.response;
      });
    return { data: responseData, status };
  },

  async deleteSettings(id: string) {
    let { data, status } = await $axios
      .delete($api("settings_id", { id }), {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .catch((err) => {
        return err.response;
      });
    return { data, status };
  },
};

